import Button from 'app/components/UI-Elements/General/Button'
import useTranslation from 'app/lib/hooks/useTranslation'
import MachineList from 'app/pages/Project/Containers/MachineList'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import { truncate } from 'lodash'
import { Link } from 'react-router-dom'

const MachineIndex: React.FC<PageProps> = () => {
  const { tRoute } = useTranslation({ scope: 'machine.show' })

  const extraColumns = [
    {
      title: tRoute({ id: 'project' }),
      dataIndex: 'project.name',
      width: 300,
      ellipsis: true,
      render: (_text: string, record: ILineItem) => (
        <Link title={record.project.name} to={Routes.Project.member(record.project.id).show}>
          <Button
            size="small"
            title={truncate(record.project.name, { length: 40 })}
            type="default"
          />
        </Link>
      )
    }
  ]

  return <MachineList props={{ extraColumns, pageSize: 20 }} />
}

export default MachineIndex
